import React from 'react';

export default function Attractions() {
  return (
    <div className="min-h-screen bg-[#FAFAFA] py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h1 className="text-4xl font-bold text-[#0A2540] mb-4">Attractions</h1>
        <p className="text-gray-600 text-lg">Coming soon: Theme parks, museums, and more</p>
      </div>
    </div>
  );
}
